import { useEffect, useState } from 'react'
import { FeatureName, useFeatureToggle } from '@app/PageLayout/handlers/useFeatureToggle'

const GITLAB_STATUS = process.env.GITLAB_STATUS || null

/**
 * @function useFeatureFlag - используется для получения состояния фича флага
 * @description специальный режим в котором можно видеть дополнительную информацию и тестировать новые функции, не мешая обычным пользователям
 * @returns {boolean} - Включается если есть фича флаги в урле
 */
const useFeatureFlag = (typeFeature?: FeatureName): boolean => {
  const [isDevMode, setIsDevMode] = useState(false)
  const { flags: featureFlags } = useFeatureToggle()

  const hasPropsFlag = !!typeFeature
  const isFlagActive = hasPropsFlag ? featureFlags[typeFeature] : false

  useEffect(() => {
    const IS_PROD =
      GITLAB_STATUS &&
      GITLAB_STATUS === '0' &&
      typeof window !== 'undefined' &&
      window?.document?.location?.host === 'www.afisha.ru'

    if (hasPropsFlag) setIsDevMode(isFlagActive)
    else setIsDevMode(!IS_PROD)
  }, [isFlagActive])

  return isDevMode
}

export default useFeatureFlag
